import AttachmentModule from './attachment.module'

export default AttachmentModule
